import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    settings: [],
};


const settingsReducer = createSlice({
    name: "settingsReducer",
    initialState: initialState,
    reducers: {
        updateSettings: (state, { type, payload }) => {
            state.settings = payload
        },
    }
})

export const { updateSettings } = settingsReducer.actions



export default settingsReducer.reducer;